import React from "react";
import Container from "../components/container";
import { Switch, Route } from "react-router-dom";
import CallbackPage from "../components/callback";
import { Shipment } from "../shipment/shipment.js";
import { Invoice } from "../invoice/invoice.js";
import Admin from "../invoice/admin/admin";
import { Sales } from "../sales/sales";
//import { ToyotaInvoicingSystem } from "../user-Maintenance/toyotaInvoicingSystem";
import { NmscUserEmailList } from "../userMaintenancePSCG/NmscUserEmailList";
const routes = (
  <div>
    <Switch>
      <Container>
        <Route exact path="" component={CallbackPage} />
        <Route path="/search" component={Shipment} />
        <Route path="/invoiceSearch" component={Invoice} />
        <Route path="/auditorAdmin" component={Admin} />
        <Route path="/salesInvoice" component={Sales} />
        {/* <Route path="/invoicingSystem" component={ToyotaInvoicingSystem} /> */}
        <Route path="/pscgInvoicingSystem" component={NmscUserEmailList} />
      </Container>
    </Switch>
  </div>
);
export default routes;

// import React from 'react';
// import Container from '../components/container';
// import { Switch, Route } from 'react-router-dom';
// import CallbackPage from '../components/callback';
// import {Shipment} from "../shipment/shipment.js";
// import {Invoice} from "../invoice/invoice.js";
// const routes = (
// <div>
//     <Switch>
//         <Container>
//         <Route exact path="" component={CallbackPage} />
//          <Route path="/search"  component={Shipment} />
//          <Route path="/invoiceSearch" component={Invoice}/>
//         </Container>
//         </Switch>
// </div>
// )
// export default routes;
